<template>
  <div class="tab pb-5">
    <template v-if="current.items.length">
      <Collapsible
        v-for="(tab, index) in current.items"
        :key="tab.id"
        class="mb-2 collapsible"
        :label="`${$t('tab.tab')} ${index + 1}`"
      >
        <Input
          :label="$t('tab.title')"
          :value="tab.title"
          @enter="updateTabsItemProp(`${index}.title`, $event)"
          @blur="updateTabsItemProp(`${index}.title`, $event)"
        />
        <hr />
        <label class="label" style="margin-bottom: -12px">{{ $t('tab.text-color') }}</label>
        <ColorPicker
          :label="$t('tab.text-color')"
          :color="tab.options[currentView].dateColor"
          @submit="value => updateTabItems({ id, path: `${index}.options.${currentView}.dateColor`, value })"
        />
        <hr />
        <Input
          :label="$t('tab.description')"
          :value="tab.description"
          @enter="updateTabsItemProp(`${index}.description`, $event)"
          @blur="updateTabsItemProp(`${index}.description`, $event)"
        />
        <hr />
        <Input
          :label="$t('tab.button')"
          :value="tab.button"
          @enter="updateTabsItemProp(`${index}.button`, $event)"
          @blur="updateTabsItemProp(`${index}.button`, $event)"
        />
        <hr />
        <label class="label">{{ $t('tab.date') }}</label>
        <b-form-datepicker
          class="mb-2"
          :value="tab.date"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          @input="updateTabsItemProp(`${index}.date`, $event)"
        />
        <hr />
        <label class="label">{{ $t('tab.time') }}</label>
        <b-form-timepicker :value="tab.time" @input="updateTabsItemProp(`${index}.time`, $event)" />
        <hr />
        <Button
          :label="$t('tab.remove')"
          @click="removeTabsItem({ id: current.id, index })"
          :disabled="current.items.length <= 1"
          icon="fas fa-trash-alt"
          :buttonStyle="{ color: 'red' }"
        />
      </Collapsible>
    </template>
    <Button
      icon="fas fa-plus"
      class="mb-2"
      :label="$t('add-tab')"
      @click="addTabsItem({ id: current.id, index: current.items.length })"
    />
    <template>
      <Divider />

      <Button
        icon="fas fa-trash-alt"
        :buttonStyle="{ color: 'red' }"
        :label="$t('remove')"
        @click="removeTabs({ id })"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ContentMixin from '@/components/sidenav/landing/shared/ContentMixin.js'
import Divider from '@/shared/components/Divider'
import Button from '@/shared/components/Button'
import Input from '@/shared/components/Input'
import Collapsible from '@/shared/components/Collapsible'
import ColorPicker from '@/shared/components/ColorPicker'

export default {
  name: 'TabsSideNavContentTab',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.tabs.content' },
  mixins: [ContentMixin],
  components: { Divider, Button, Input, Collapsible, ColorPicker },
  methods: {
    ...mapActions('landing', ['removeTabs', 'updateTabItems', 'addTabsItem', 'removeTabsItem']),
    updateTabsItemProp(path, value) {
      this.updateTabItems({ id: this.activeId, path, value })
    },
  },
  computed: {
    ...mapGetters('landing', ['objectById']),
    ...mapState('landing', {
      activeId: state => state.activeId,
    }),
    current() {
      return this.objectById(this.activeId)
    },
  },
}
</script>

<style lang="scss" scoped>
.collapsible {
  .label {
    display: block;
    font-weight: 700;
  }
}
.collapsible + .collapsible {
  border-top: 1px solid #e9e9e9;
}
</style>
